module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/data-second-bg.de2e6b43.png";